{
  "api": {
    "locationValidationTitle": "Нам не вдалось підтвердити ваше місцезнаходження",
    "thresholdTitle": "Ви не встигаєте до реєстрації",
    "warehouseUnavailableTitle": "Склад недоступний",
    "warehouseUnavailableMessage": "Будь ласка, зверніться до персоналу об'єкта для ручної реєстрації",
    "characterLimitTitle": "Введення перевищує ліміт символів",
    "genericTitle": "Реєстрація не вдалась. Будь ласка, спробуйте знову.",
    "recaptchaTitle": "Перевірку не пройдено",
    "recaptchaMessage": "Не вдалося перевірити ваш запит. Спробуйте знову або зверніться до персоналу об'єкта."
  }
}
